import React from 'react';
import { useChartInteractionDispatch, useChartInteractionState } from '../ChartInteractionProvider';
import { useChartWrapperContext } from '../ChartWrapper';

const showTooltipAtSlice = <Datum>(
  datumId: string,
  datum: Datum,
  showTooltip: (args: { data: Datum; x: number; y: number }) => void,
  container: HTMLElement | null
) => {
  const el = container?.querySelector<SVGElement>(`[data-datum-id="${datumId}"]`);
  if (!el) return;
  const rect = el.getBoundingClientRect();
  showTooltip({ data: datum, x: rect.x + rect.width / 2, y: rect.y });
};

export const useLegendInteractions = () => {
  const { setHighlight, showTooltip, hideTooltip, handleItemClick } = useChartInteractionDispatch();
  const { highlightedItem, isPinned } = useChartInteractionState();
  const { wrapperRef } = useChartWrapperContext();

  return {
    onPointerEnter: (datum: unknown, id: string, index: number) => {
      setHighlight({ datum, id, index });
      if (!isPinned) showTooltipAtSlice(id, datum, showTooltip, wrapperRef.current);
    },
    onPointerLeave: () => {
      setHighlight(null);
      hideTooltip();
    },
    onClick: (event: React.MouseEvent, datum: unknown, id: string, index: number) => {
      const isUnpin = isPinned && highlightedItem === id;
      handleItemClick(event, { datum, id, index });
      if (!isUnpin) showTooltipAtSlice(id, datum, showTooltip, wrapperRef.current);
    },
  };
};
